import React from "react";
import { IconSize, IconProps } from "../theme";

const ThumbsUp: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4531 4.63344C15.2947 4.45395 15.1 4.31021 14.8818 4.21177C14.6635 4.11334 14.4269 4.06245 14.1875 4.0625H10.25V2.9375C10.25 2.19158 9.95368 1.47621 9.42624 0.948762C8.89879 0.421316 8.18342 0.125 7.4375 0.125C7.333 0.124925 7.23054 0.153963 7.14162 0.208856C7.0527 0.263749 6.98083 0.342328 6.93406 0.435781L4.27766 5.75H1.25C0.951631 5.75 0.665483 5.86853 0.454505 6.0795C0.243526 6.29048 0.125 6.57663 0.125 6.875V13.0625C0.125 13.3609 0.243526 13.647 0.454505 13.858C0.665483 14.069 0.951631 14.1875 1.25 14.1875H13.3438C13.7549 14.1876 14.1519 14.0377 14.4603 13.7658C14.7687 13.4939 14.9672 13.1188 15.0186 12.7109L15.8623 5.96094C15.8923 5.7233 15.8712 5.48201 15.8007 5.25313C15.7301 5.02424 15.6116 4.813 15.4531 4.63344ZM1.25 6.875H4.0625V13.0625H1.25V6.875Z"
        fill="#071443"
      />
    </svg>
  );
};

export default ThumbsUp;
